import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import Cookies from 'js-cookie';
import Dropdown from 'react-bootstrap/Dropdown';
import {useNavigate, NavLink} from 'react-router-dom'
export default function Header() {
  const [userData, setUserData] = useState(null)
  const navigate = useNavigate()
  const logout = ()=>{
    Cookies.remove("userData")
    Cookies.remove("userToken")
    navigate("/login")
  }
  useEffect(() => {
    let cookieuserData = Cookies.get("userData")
    if (cookieuserData) {
      setUserData(JSON.parse(cookieuserData))
    }
    else{
       setUserData(null)
    }

  }, [])
  return (
    <Navbar bg="dark" data-bs-theme="dark">
      <Container>
        <Navbar.Brand><Link to="/ " className="text-white">Doctor Assistant</Link> </Navbar.Brand>
        {
          userData ?
           <Nav className="ms-auto">
          <Dropdown>
            <Dropdown.Toggle variant="link" className="userAvatar">
            {
            userData.role === "admin" && <>Dr.</>
            } 
             {userData.name} 
            <span>
              <img src={userData.avatar}alt={userData.name}  />
            </span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Link className="dropdown-item" to="../doctor-dashboard/profile">Profile</Link>
               <Link className="dropdown-item" to="../doctor-dashboard">Dashboard</Link>
              {/* <Dropdown.Item href="#/action-2">Another action</Dropdown.Item> */}
              <Dropdown.Item as="button" onClick={logout}>Log Out</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {/* <Nav.Link to="/">Dr. {userData.name}</Nav.Link> */}
        </Nav>
        :
         <Nav className="ms-0">
            <NavLink className="nav-link" to="/">Home</NavLink>
             <NavLink className="nav-link" to="/about">About</NavLink>
             <NavLink className="nav-link" to="/contact">Contact</NavLink>
             <NavLink className="nav-link" to="/login">Login</NavLink>
             <NavLink className="nav-link" to="/signup">Signup</NavLink>
            
          </Nav>
        }
       
      </Container>
    </Navbar>
  )

}